import { Address } from 'viem';

import { Vault } from '@/features/vaults/types';

export const rootstockTyrRbtcVaultId = 'rootstock-tyr-rbtc';

const rootstockTyrRbtcVaultAddress: Address = '0x97Bb1d1b9FaA1091406A005F0B4a1658e5b542Eb';

export const rootstockTyrRbtcVault: Vault = {
  id: rootstockTyrRbtcVaultId,
  type: 'core-vault',
  category: 'core-vault',
  name: 'Tyr Capital on Rootstock (BTC)',
  description:
    'Tyr Capital’s rBTC Vault seeks to generate rBTC-denominated yield via market-neutral and arbitrage strategies that capture liquidity, basis, and cross-venue pricing inefficiencies across spot and derivatives markets.' +
    '\n\n' +
    'This vault’s NAV is calculated at the beginning of each month.' +
    '\n\n' +
    'Deposits must be submitted at least 72 hours before the report, and withdrawals at least 15 days before the report.',
  address: rootstockTyrRbtcVaultAddress,
  network: 'rootstock',
  networks: [
    {
      network: 'rootstock',
      vaultAddress: rootstockTyrRbtcVaultAddress,
    },
  ],
  curators: ['tyr'],
  operator: [],
  baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
  lpTokenSymbol: 'Tyr.rBTC',
  lpTokenDecimals: 18,
  allocations: {
    showAllocationsTab: false,
  },
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  deposit: {
    whitelistReason: ({ userAddress, isDepositorWhitelisted }) => {
      if (userAddress && !isDepositorWhitelisted) {
        return 'This is a private vault that only accepts deposits from a set of whitelisted addresses.\n\nYou have to complete the KYC verification and then you can make a deposit.\n\nKYC code is recIp5yPL76WqBfkJrec6HWY4KaRstiIZb';
      }

      if (!userAddress) {
        return 'This is a private vault that only accepts deposits from a set of whitelisted addresses.';
      }

      return null;
    },
    kycLink: 'https://dashboard.chartergroupadmin.com/whitelist',
  },
  predictedPerformanceFee: 20,
  predictedProtocolFee: 2.5,
  depositPendingPeriod: '~3-33 days',
  withdrawalPendingPeriod: '~15-45 days',
};
